import { z, ZodType } from 'zod'

import { adUnitsAttributesSchema } from 'features/inventory/domain/components/ProductAdUnitsTable'
import { matchTypeValues } from 'features/inventory/domain/types/matchType'
import { Domain } from 'features/inventory/types/domain'
import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { zPercentage } from 'utils/zod'

export const desktopAdThreshold: ZodType<number> = zPercentage
export const desktopMonitorUserScrollEnabled: ZodType<boolean> = z.boolean()
export const desktopRefreshInterval: ZodType<number> = z.number().min(0).max(MAX_SAFE_GQL_INTEGER)
export const mobileAdThreshold: ZodType<number> = zPercentage
export const mobileMonitorUserScrollEnabled: ZodType<boolean> = z.boolean()
export const mobileRefreshInterval: ZodType<number> = z.number().min(0).max(MAX_SAFE_GQL_INTEGER)

export const schema = z
  .object({
    advertiserIds: z.string().array(),
    desktopAdThreshold,
    desktopMonitorUserScrollEnabled,
    desktopRefreshInterval,
    domainId: z.string(),
    lineItemIds: z.string().array(),
    lineItemName: z.string().array(),
    lineItemPriority: z.string().array(),
    matchType: z.enum(matchTypeValues),
    mobileAdThreshold,
    mobileMonitorUserScrollEnabled,
    mobileRefreshInterval,
    orderIds: z.string().array(),
    refresherEnabled: z.boolean(),
    targetingEnabled: z.boolean(),
  })
  .extend(adUnitsAttributesSchema.shape)

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({ domainRefresher }: Domain): Schema => ({
  ...domainRefresher,
  adUnitsAttributes: {},
  lineItemPriority: domainRefresher.lineItemPriority.map((priority: number): string =>
    priority.toString(),
  ),
})
